import { LayoutElement } from '../../../types/models/Elements';
import { panoramicLayouts5MorePhotos } from '../panoramic/5morePhotos';

export const mugLayouts5MorePhotos: LayoutElement[][] = [
  ...panoramicLayouts5MorePhotos,
];
